module.exports = __webpack_public_path__ + "static/media/ios_share.59060f01.svg";